"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessLoggerDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.BusinessLoggerDefinition = (0, static_service_1.defineStaticService)('viewer-core/business-logger');
//# sourceMappingURL=index.js.map